// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.timeline-global-div
{
    
    width:100%;
    height: 100%;
    background-color: transparent;

}

.timeline-timeline-div
{
    display: flex;
    justify-content: space-between; /* Aligne les div avec de l'espace entre elles */    
    width:100%;
    height: 100%;

    background-color: "transparent";
}

.timeline-left-div
{
    width:var(--timeline-left-width);
    height: 100%;
    background-color: #101010;
    display: flex;

}

.timeline-right-div
{
    width: calc(100% - var(--timeline-left-width));
    height: 100%;
    background-color: transparent;
    position: relative;

}

.timeline-right-right-div
{

    width: 15px;
    height: 100%;
    background-color: #101010;
    
    border-width: 1px;
    border-color: #303030;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: visible; 
    font-family: 'Courier New', Courier, monospace;   
    
}

.timeline-right-right-div span {
    transform: rotate(90deg) translateY(-2px);
    white-space: nowrap;
    display: inline-block;
}

.timeline-bottom-left-div
{
    height: 100%;
    width: var(--timeline-left-width);
    
    background-color: #202020;
}

.timeline-bottom-middle-div
{
    height: 100%;
    width: calc(100% - var(--timeline-left-width) - 100px);
    background-color: #202020;
}

.timeline-bottom-right-div
{
    text-align: right;
    width: 100px;
    height: 100%;
    background-color: #202020;
}



.timeline-canvas-right-layer
{
    width:100%;
    height: 100%;
    background-color: "transparent";
}

.timeline-canvas-left-layer
{
    width:100%;
    height: 100%;
}





.context-menu-sequence {
    position: fixed;
    z-index: 10000;
    font-size: 14px;
    min-width: 180px;

    background: #303030;
    border: 1px solid #555;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    padding: 4px 0;
}

.context-menu-item-sequence-title
{
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 4px;
    background-color: #1E293B;
    border-radius: 3px;
    width: 98%;
    margin-left: 1%;
    margin-right: 1%;
    text-align: center;
    color: #eee;
    cursor: pointer;
    white-space: nowrap;

}

.context-menu-item-sequence {
    padding-left: 8px;
    padding-right: 8px;
    color: #eee;
    cursor: pointer;
    white-space: nowrap;
}

.context-menu-item-sequence-disable {
    padding-left: 8px;
    padding-right: 8px;
    color: #404040;
    cursor: pointer;
    white-space: nowrap;
}


.context-menu-item-sequence:hover {
    background: #5050a0;
}





`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/timeline/timeline.css"],"names":[],"mappings":";;AAEA;;;IAGI,UAAU;IACV,YAAY;IACZ,6BAA6B;;AAEjC;;AAEA;;IAEI,aAAa;IACb,8BAA8B,EAAE,gDAAgD;IAChF,UAAU;IACV,YAAY;;IAEZ,+BAA+B;AACnC;;AAEA;;IAEI,gCAAgC;IAChC,YAAY;IACZ,yBAAyB;IACzB,aAAa;;AAEjB;;AAEA;;IAEI,8CAA8C;IAC9C,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;;AAEtB;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,yBAAyB;;IAEzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,8CAA8C;;AAElD;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;IACZ,iCAAiC;;IAEjC,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,sDAAsD;IACtD,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;;;AAIA;;IAEI,UAAU;IACV,YAAY;IACZ,+BAA+B;AACnC;;AAEA;;IAEI,UAAU;IACV,YAAY;AAChB;;;;;;AAMA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;;IAEhB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;;AAEvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;;AAGA;IACI,mBAAmB;AACvB","sourcesContent":["\n\n.timeline-global-div\n{\n    \n    width:100%;\n    height: 100%;\n    background-color: transparent;\n\n}\n\n.timeline-timeline-div\n{\n    display: flex;\n    justify-content: space-between; /* Aligne les div avec de l'espace entre elles */    \n    width:100%;\n    height: 100%;\n\n    background-color: \"transparent\";\n}\n\n.timeline-left-div\n{\n    width:var(--timeline-left-width);\n    height: 100%;\n    background-color: #101010;\n    display: flex;\n\n}\n\n.timeline-right-div\n{\n    width: calc(100% - var(--timeline-left-width));\n    height: 100%;\n    background-color: transparent;\n    position: relative;\n\n}\n\n.timeline-right-right-div\n{\n\n    width: 15px;\n    height: 100%;\n    background-color: #101010;\n    \n    border-width: 1px;\n    border-color: #303030;\n    border-radius: 3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: visible; \n    font-family: 'Courier New', Courier, monospace;   \n    \n}\n\n.timeline-right-right-div span {\n    transform: rotate(90deg) translateY(-2px);\n    white-space: nowrap;\n    display: inline-block;\n}\n\n.timeline-bottom-left-div\n{\n    height: 100%;\n    width: var(--timeline-left-width);\n    \n    background-color: #202020;\n}\n\n.timeline-bottom-middle-div\n{\n    height: 100%;\n    width: calc(100% - var(--timeline-left-width) - 100px);\n    background-color: #202020;\n}\n\n.timeline-bottom-right-div\n{\n    text-align: right;\n    width: 100px;\n    height: 100%;\n    background-color: #202020;\n}\n\n\n\n.timeline-canvas-right-layer\n{\n    width:100%;\n    height: 100%;\n    background-color: \"transparent\";\n}\n\n.timeline-canvas-left-layer\n{\n    width:100%;\n    height: 100%;\n}\n\n\n\n\n\n.context-menu-sequence {\n    position: fixed;\n    z-index: 10000;\n    font-size: 14px;\n    min-width: 180px;\n\n    background: #303030;\n    border: 1px solid #555;\n    border-radius: 4px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n    padding: 4px 0;\n}\n\n.context-menu-item-sequence-title\n{\n    padding-left: 8px;\n    padding-right: 8px;\n    padding-bottom: 4px;\n    background-color: #1E293B;\n    border-radius: 3px;\n    width: 98%;\n    margin-left: 1%;\n    margin-right: 1%;\n    text-align: center;\n    color: #eee;\n    cursor: pointer;\n    white-space: nowrap;\n\n}\n\n.context-menu-item-sequence {\n    padding-left: 8px;\n    padding-right: 8px;\n    color: #eee;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.context-menu-item-sequence-disable {\n    padding-left: 8px;\n    padding-right: 8px;\n    color: #404040;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n\n.context-menu-item-sequence:hover {\n    background: #5050a0;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
